module.exports = __webpack_public_path__ + "favicon-32.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/web/favicon-32.ico
// module id = 1062
// module chunks = 0